// extracted by mini-css-extract-plugin
export default {"userStat":"UserStat_userStat__RjJOY","info":"UserStat_info__e54Ro","infoTitle":"UserStat_infoTitle__gU95K","infoNumber":"UserStat_infoNumber__9kBET"};